export const environment:{[key: string]: any} = {
  frontendUrl: 'https://staging.shrimp.de',
  shortnameRedirectUrl: 'https://go2.shrimp.de',
  backendBaseUrl: 'https://backend-staging.shrimp.de',
  backendPdfUrl: 'https://backend-pdf-staging.shrimp.de',
  dev: true,
  httpDefaultTimeout: 80000,
  idps: [{
    name: 'ac',
    loginEndpoint:'login-ac',
    description: '',
  },{
    name: 'mbr',
    loginEndpoint: 'login-mbr',
    description: '',
  },{
    name: 'satosa',
    loginEndpoint: 'login_satosa',
    description: '',
  },{
    name: 'local',
    loginEndpoint: '*local',
    description: '',
  }]
}
